module.exports = __webpack_public_path__ + "fonts/HarmonyOS_Sans_SC_Black.8ff4ebb1.ttf";